(function () {
    'use strict';

    angular
        .module('app')
        .controller('viewerUserSettings', viewerUserSettings);

    //TD 05-11-2021 Added $rootScope for msgBox and clientService for clear viewer cache call.
    viewerUserSettings.$inject = ['$rootScope', 'viewerUserSettingsService', '$mdDialog', '$filter', 'loginService', 'clientService'];

    function viewerUserSettings($rootScope, viewerUserSettingsService, $mdDialog, $filter, loginService, clientService) {
        var vm = this;

        vm.viewerUserSettingsDisplayLabel = loginService.resourceStrings["VIEWER_USER_SETTINGS_TAB_LABEL"]; // "Document Dashboard Display and Virtual Library Population"
        vm.viewerUserSettingsDisplayDetailLabel = loginService.resourceStrings["VIEWER_USER_SETTINGS_DETAIL_LABEL"]; // "Options to speed up loading of Document Dashboard"

        vm.autoLoadMarkupLabel = loginService.resourceStrings["VIEWER_AUTO_LOAD_MARKUP_LABEL"];
        vm.autoLoadMarkup = loginService.resourceStrings["VIEWER_AUTO_LOAD_MARKUP"];

        vm.zoomFitLabel = loginService.resourceStrings["VIEWER_ZOOM_FIT_LABEL"];
        vm.zoomFit = loginService.resourceStrings["VIEWER_ZOOM_FIT"];

        vm.clearViewerCacheOnLogoutLabel = loginService.resourceStrings["VIEWER_CLEAR_CACHE_ON_LOGOUT_LABEL"];
        vm.clearViewerCacheOnLogout = loginService.resourceStrings["VIEWER_CLEAR_CACHE_ON_LOGOUT"];
        vm.clearViewerCacheSuccess = loginService.resourceStrings["VIEWER_CLEAR_CACHE_SUCCESS"];
        vm.creator = loginService.creator

        vm.okLabel = loginService.resourceStrings["OK"]; // "OK"
        vm.cancelLabel = loginService.resourceStrings["CANCEL"]; // "Cancel"

        vm.bAutoLoadMarkup = false;
        vm.bZoomFit = false;
        vm.bClearCacheOnLogout = false;

        vm.changed = false;
        activate();
        vm.viewerUserSettingsService = viewerUserSettingsService;
        vm.loadingDataLabel = loginService.resourceStrings["LOADING_DATA"]; // "Loading Data"

        viewerUserSettingsService.getViewerUserSettings().then(function (data) {
            if (data != null) {
                console.log("getViewerUserSettings returned data");
                vm.bAutoLoadMarkup = data.ViewerLoadMarkup;
                vm.bZoomFit = data.ViewerZoomFit;
                vm.bClearCacheOnLogout = data.ClearCacheOnLogout;
            }
            else
                console.log("getViewerUserSettings returned null");
        });

        // Call into ACS to clear the Viewer cache
        vm.onClearCache = function () {
            var title = loginService.resourceStrings["VIEWER"];
            var msg = loginService.resourceStrings["VIEWER_CLOSED_SAVE_CURRENT_MARKUPS"];
            $rootScope.confirmBoxShow("", "", title, msg, "", clearCacheConfirmPostCloseCallback);
        }

        // Callback from the confirm box after the box has closed
        var clearCacheConfirmPostCloseCallback = function (param1, param2, okSelected) {
            if (okSelected) {
                clientService.get('viewer/ClearCache').then(function () {
                    viewerUserSettingsService.markupUnlockByUser().then(function () {
                        $rootScope.msgBoxShow(vm.clearViewerCacheSuccess, vm.clearViewerCacheOnLogoutLabel, 1);
                    })
                });
            }
        }

        //when the ok button is clicked
        vm.onOk = function () {
            //set the fields
            var userOptions = {
                ViewerLoadMarkup: vm.bAutoLoadMarkup,
                ViewerZoomFit: vm.bZoomFit,
                ClearCacheOnLogout: vm.bClearCacheOnLogout
            }

            //var packet = JSON.stringify(userOptions);
            viewerUserSettingsService.setViewerUserSettings(userOptions).then(function () {
                $mdDialog.hide();
            })
        }

        //when the cancel button is clicked
        vm.onCancel = function () {
            $mdDialog.cancel();
        }

        function activate() { }
    }
})();
